import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Service from "./../webservice/http";
import { useHistory } from "react-router-dom";
import { storage } from "../utils/storage";

const NavBar = () => {
  const services = new Service();
  var url = window.location.href;
  url = url.replace(/^.*\/\/[^\/]+/, "");
  const [permission, setPermission] = useState();

  const history = useHistory();

  /**
   * Fetch all the permission details for the logged in user
   *
   * Based on permission details nav will be populated
   *
   */
  function fetch_permissionDetails() {
    services.get("api/access_control/permission_details/").then((res) => {
      // console.log(res);
      if (res == "TypeError: Failed to fetch") {
      } else {
        try {
          if (res.code == "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          setPermission(res);
        } catch (e) {
          // console.log(e);
        }
      }
    });
  }

  useEffect(() => {
    fetch_permissionDetails();
  }, [url]);

  return (
    <div className="main-nav clearfix">
      <div className="sale" style={{ fontSize: "14px" }}>
        <div>
          <img
            src="/assets/images/grid.png"
            className="img-responsive"
            alt=""
          />{" "}
          {storage.getItem("usecase") === "Complaints Management"
            ? "Customer Service"
            : storage.getItem("client_name") === "Standard Chartered"
              ? "Banking-Collections"
              : storage.getItem("client_name") === "General Collections"
                ? "Banking-Collection"
                : storage.getItem("client_name") === "Maya Bank Collections"
                  ? "Banking Collections"
                  : storage.getItem("client_name") === "UNO Bank Collections"
                    ? "Banking Collections"
                    : storage.getItem("usecase")}
        </div>
      </div>
      <div className="main-menu">
        <nav className="nav-primary">
          <ul key="ul" className="menu-main-navigation menu clearfix">
            <li key="home" className={url === "/" ? "active" : ""}>
              <Link to={"/"}>Home</Link>
            </li>
            {permission &&
              permission.map((p) => (
                <>
                  {p.feature == "Call List" && (
                    <li
                      key={p.feature}
                      className={
                        url.includes("ticket-list") ||
                        url.includes("call-list") ||
                        url.includes("call-insight") ||
                        url.includes("deep-analysis") ||
                        url.includes("transcription-audit") ||
                        url.includes("live-call")
                          ? "active"
                          : ""
                      }
                    >
                      {" "}
                      {storage.getItem("usecase") ===
                      "Complaints Management" ? (
                        <Link to={"/ticket-list"}>Tickets</Link>
                      ) : (
                        <Link to={"/call-list"}>Calls</Link>
                      )}
                    </li>
                  )}
                </>
              ))}

            {permission &&
              permission.map((p) => (
                <>
                  {p.feature == "Dashboard" && (
                    <li
                      key={p.feature}
                      className={url === "/dashboard" ? "active" : ""}
                    >
                      {" "}
                      <Link to={"/dashboard"}>Dashboard</Link>
                    </li>
                  )}
                </>
              ))}

            {permission &&
              storage.getItem("usecase") !== "Complaints Management" &&
              permission.map((p) => (
                <>
                  {p.feature == "Opportunity" && (
                    <li
                      key={p.feature}
                      className={
                        url === "/call/opportunities" ||
                        url.includes("opportunity-details")
                          ? "active"
                          : ""
                      }
                    >
                      {" "}
                      <Link to={"/call/opportunities"}>Opportunities</Link>
                    </li>
                  )}
                </>
              ))}
            {permission &&
              permission.map((p) => (
                <>
                  {p.feature == "Promise to Pay" && (
                    <li
                      key={p.feature}
                      className={
                        url === "/call/call-status" ||
                        url.includes("promise-details") ||
                        url.includes("call-status-details")
                          ? "active"
                          : ""
                      }
                    >
                      {" "}
                      <Link to={"/call/call-status"}>Call Status</Link>
                    </li>
                  )}
                </>
              ))}

            {permission &&
              storage.getItem("usecase") !== "Complaints Management" &&
              permission.map((p) => (
                <>
                  {p.feature == "Service Request" && (
                    <li
                      key={p.feature}
                      className={
                        url === "/call/service-requests" ||
                        url === "/ticket/service-requests"
                          ? "active"
                          : ""
                      }
                    >
                      <Link to={"/call/service-requests"}>
                        {" "}
                        Service Requests
                      </Link>
                    </li>
                  )}
                </>
              ))}

            {permission &&
              permission.map((p) => (
                <>
                  {p.feature == "Archive Call" && (
                    <li
                      key={p.feature}
                      className={
                        url === "/call/archive-calls" ||
                        url === "/ticket/archive-calls"
                          ? "active"
                          : ""
                      }
                    >
                      {" "}
                      {storage.getItem("usecase") ===
                      "Complaints Management" ? (
                        <Link to={"/ticket/archive-tickets"}>
                          Archived Tickets
                        </Link>
                      ) : (
                        <Link to={"/call/archive-calls"}>Archived Calls</Link>
                      )}
                    </li>
                  )}
                </>
              ))}

            {permission &&
              permission.map((p) => (
                <>
                  {p.feature == "Contact" && (
                    <li
                      key={p.feature}
                      className={
                        url.substr(0, 8) === "/contact" ? "active" : ""
                      }
                    >
                      {" "}
                      <Link to={"/contact"}>Contact</Link>
                    </li>
                  )}
                </>
              ))}

            {permission &&
              permission.map((p) => (
                <>
                  {p.feature == "Task" && (
                    <li
                      key={p.feature}
                      className={url.includes("/my-things") ? "active" : ""}
                    >
                      {" "}
                      <Link
                        to={
                          storage.getItem("username") === "MYABCQT01" ||
                          storage.getItem("username") === "MYABCMR01"
                            ? "/my-things/my-thing"
                            : storage.getItem("username") === "MYABCNG01" ||
                              storage.getItem("username") === "GNLNNT01"
                            ? "/my-things/collection-strategy"
                            : "/my-things/task"
                        }
                      >
                        My Things
                      </Link>
                    </li>
                  )}
                </>
              ))}

            {permission &&
              permission.map((p) => (
                <>
                  {p.feature == "User Management" && (
                    <li
                      key={p.feature}
                      className={
                        url.substr(0, 16) === "/user-management" ? "active" : ""
                      }
                    >
                      {" "}
                      <Link
                        to={
                          storage.getItem("role") === "LOB"
                            ? "/user-management/manage-role"
                            : "/user-management/manage-user"
                        }
                      >
                        User Management
                      </Link>
                    </li>
                  )}
                </>
              ))}

            {permission &&
              permission.map((p) => (
                <>
                  {p.feature == "Quality Audit" && (
                    <li
                      key={p.feature}
                      className={
                        url.substr(0, 16) === "/quality-audit" ? "active" : ""
                      }
                    >
                      {" "}
                      <Link to={"/quality-audit"}>Quality Audit</Link>
                    </li>
                  )}
                </>
              ))}

            {permission &&
              permission?.map((p) => (
                <>
                  {p.feature == "Report" &&
                    (storage.getItem("usecase") !==
                      "Insurance - PCVC Verification" &&
                    storage.getItem("client") !== "DBS Bank Singapore" &&
                    storage.getItem("client") !== "SP Madrid" &&
                    storage.getItem("client") !== "Maya Bank Collections" &&
                    storage.getItem("client") !== "HDFC Life Digital" &&
                    storage.getItem("client") !== "Prudential Insurance" &&
                    !storage.getItem("client").includes("Collections") ? (
                      <li
                        key={p.feature}
                        className={
                          url.substr(0, 8) === "/reports" ? "active" : ""
                        }
                      >
                        {" "}
                        <Link to={"/reports/service-request"}>Reports</Link>
                      </li>
                    ) : storage.getItem("client") === "DBS Bank Singapore" ? (
                      <li
                        key={p.feature}
                        className={
                          url.substr(0, 8) === "/reports" ? "active" : ""
                        }
                      >
                        {" "}
                        <Link to={"/reports/forex"}>Reports</Link>
                      </li>
                    ) : storage.getItem("client") === "SP Madrid" ? (
                      <li
                        key={p.feature}
                        className={
                          url.substr(0, 8) === "/reports" ? "active" : ""
                        }
                      >
                        {" "}
                        <Link to={"/reports/promise-to-pay"}>Reports</Link>
                      </li>
                    ) : storage.getItem("usecase").includes("Collections") ? (
                      <li
                        key={p.feature}
                        className={
                          url.substr(0, 8) === "/reports" ||
                          url.includes("/detailed-reports") ||
                          url.includes("/edit-report") ||
                          url.includes("/revised-report") ||
                          url.includes("latedue-detail") ||
                          url.includes("postduegreater-detail") ||
                          url.includes("postdueless-detail")
                            ? "active"
                            : ""
                        }
                      >
                        {" "}
                        <Link
                          to={
                            storage.getItem("role") === "Agent" ||
                            storage.getItem("role") === "Agenth" ||
                            storage.getItem("role") === "Agent Collections" ||
                            storage.getItem("role") === "DCA Agent"
                              ? "/reports/agent-scorecard"
                              : "/reports/my-reports"
                          }
                        >
                          Reports
                        </Link>
                      </li>
                    ) : storage.getItem("client") === "HDFC Life Digital" ||
                      storage.getItem("client") === "Prudential Insurance" ? (
                      <li
                        key={p.feature}
                        className={url.includes("/reports") ? "active" : ""}
                      >
                        {" "}
                        <Link to={"/reports/reports-dashboard"}>Reports</Link>
                      </li>
                    ) : (
                      <li
                        key={p.feature}
                        className={
                          url.substr(0, 8) === "/reports" ? "active" : ""
                        }
                      >
                        {" "}
                        <Link to={"/reports/dashboard"}>Reports</Link>
                      </li>
                    ))}
                </>
              ))}
            {permission &&
              !storage.getItem("role").includes("Agent") &&
              storage.getItem("role") !== "Agenth" &&
              storage.getItem("role") !== "Agent Collections" &&
              storage.getItem("role") !== "Agent" && (
                <li
                  // key={p.feature}
                  className={
                    url.substr(0, 16) === "/access-logs" ? "active" : ""
                  }
                >
                  {" "}
                  <Link to={"/access-logs"}>Access Logs</Link>
                </li>
              )}
            {/* {permission && (
              <li
                // key={p.feature}
                className={url.substr(0, 16) === "/lob-home" ? "active" : ""}
              >
                {" "}
                <Link to={"/lob-home"}>LOB Home</Link>
              </li>
            )} */}
            {storage.getItem("client") === "DBS Bank Singapore" && (
              <li
                // key={p.feature}
                className={
                  url.substr(0, 16) === "/media-advisory" ? "active" : ""
                }
              >
                {" "}
                <Link to={"/media-advisory"}>Media Advisory</Link>
              </li>
            )}
          </ul>
        </nav>
        <div className="toggle-menu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
